const mockApi = () => {
  import("./auth");
  import("./numbers");
  import("./history");
  import("./messages");
  import("./voicemail");
};

export default mockApi;
